import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-prev",
  "use": "icon-prev-usage",
  "viewBox": "0 0 13 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 12\" id=\"icon-prev\"><path d=\"M9.998 10L4.736 6l5.262-4v8zm-7.367-.5v-7\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol